/**
 * @generated SignedSource<<7b3dc5f911a8a623579ba6a9c072c03e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectPhotoLikeWrapper_tradePhoto$data = {
  readonly id: string;
  readonly serviceId: string | null;
  readonly url: string | null;
  readonly " $fragmentType": "ProjectPhotoLikeWrapper_tradePhoto";
};
export type ProjectPhotoLikeWrapper_tradePhoto$key = {
  readonly " $data"?: ProjectPhotoLikeWrapper_tradePhoto$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectPhotoLikeWrapper_tradePhoto">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectPhotoLikeWrapper_tradePhoto",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "TradePhoto",
  "abstractKey": null
};

(node as any).hash = "43256b8b9622bda112fda1fee1ef6877";

export default node;
